export default __webpack_public_path__ + "static/media/s.5fd93428.svg";